module.exports = __webpack_public_path__ + "deutungen.png?6051b1f3f9ea0a3647fbdcb75fb2b6ec";


//////////////////
// WEBPACK FOOTER
// ./lib/assets/deutungen.png
// module id = 12
// module chunks = 0